import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { fromJS, Map, Record } from "immutable";
import { isNumber } from "underscore";
import { DateStringNumber } from "common/records";

export const paymentFromJSON = (json: Partial<IPaymentData>): PaymentRecord => {
  const record: IPaymentRecord = { ...(json as any) };

  if (json.amount && !isNumber(json.amount)) {
    record.amount = parseFloat(json.amount as string);
  }

  if (json.payload) {
    record.payload = fromJS(json.payload);
  }
  if (json.payment_date) {
    record.payment_date = checkDate(json.payment_date);
  }

  if (json.created_at) {
    record.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = checkDate(json.updated_at);
  }

  return new PaymentRecord(record);
};

export type PaymentChargeType = "ach" | "credit_card";

export interface IPaymentData {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  description: string;

  charge_type: PaymentChargeType;
  amount: string | number;
  status: string;
  kind: string;
  payment_date: Nullable<DateStringNumber>;
  is_debit: boolean;
  payload: any;

  job_id: Nullable<number>;
  org_id: Nullable<number>;
  user_id: Nullable<number>;
  estimate_id: Nullable<number>;
  pay_simple_customer_id: Nullable<number>;

  created_at: Nullable<DateStringNumber>;
  updated_at: Nullable<DateStringNumber>;
}

export type PaySimplePaymentKeys =
  | "CustomerId"
  | "FailureData"
  | "CustomerFirstName"
  | "CustomerLastName"
  | "authcode"
  | "Id";

export interface IPaymentRecord extends IPaymentData {
  payload: Map<PaySimplePaymentKeys, string | Map<string, string>>;
  amount: number;

  created_at: Nullable<Date>;
  updated_at: Nullable<Date>;

  loading: boolean;
}

const defaultPaymentProps: IPaymentRecord = {
  id: -1,
  first_name: "",
  last_name: "",
  email: "",
  description: "",
  charge_type: "credit_card",
  amount: 0,
  status: "created",
  kind: "",
  is_debit: false,
  payload: Map<PaySimplePaymentKeys, string | Map<string, string>>(),
  payment_date: null,

  org_id: null,
  job_id: null,
  user_id: null,
  estimate_id: null,
  pay_simple_customer_id: null,

  created_at: null,
  updated_at: null,

  loading: false,
};

export class PaymentRecord extends Record(defaultPaymentProps) implements IPaymentRecord {}
